/* global BigInt */

function steamId64ToHex(steamId64) {
  if (!steamId64) return '';

  const steamIdBigInt = BigInt(steamId64);
  const hexString = steamIdBigInt.toString(16);
  return `steam:${hexString}`;
}

function hexToSteamId64(hexSteamId) {
  if (!hexSteamId) return ''; // Check if hexSteamId is defined

  const [, steamid] = hexSteamId.split(':');
  if (!steamid) return ''; // Check if steamid is defined

  const steamIdBigInt = BigInt(`0x${steamid}`);
  return steamIdBigInt.toString();
}

export { steamId64ToHex, hexToSteamId64 };